import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/domains';
export var CREATE_ANSWER_COMMENT_USE_CASE = 'CREATE_ANSWER_COMMENT_USE_CASE';
export var CreateAnswerCommentUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateAnswerCommentUseCase, _UseCase);

  var _super = _createSuper(CreateAnswerCommentUseCase);

  function CreateAnswerCommentUseCase(submissionRepository) {
    var _this;

    _classCallCheck(this, CreateAnswerCommentUseCase);

    _this = _super.call(this);
    _this.submissionRepository = submissionRepository;
    return _this;
  }

  _createClass(CreateAnswerCommentUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      var collection = [{
        argument: useCaseInput.submissionId,
        argumentName: 'Submission Id'
      }, {
        argument: useCaseInput.commentId,
        argumentName: 'Essay Comment Id'
      }, {
        argument: useCaseInput.commentContent,
        argumentName: 'Essay Comment Content'
      }, {
        argument: useCaseInput.submissionAnswerContent,
        argumentName: 'Essay Answer Content'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var resultOrError, answer, submissionAnswerContent, commentId, commentContent, submissionId, id, createAnswerComment, createAnswerCommentOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                answer = useCaseInput.answer, submissionAnswerContent = useCaseInput.submissionAnswerContent, commentId = useCaseInput.commentId, commentContent = useCaseInput.commentContent, submissionId = useCaseInput.submissionId, id = useCaseInput.id;
                createAnswerComment = {
                  id: id,
                  submissionId: submissionId,
                  commentId: commentId,
                  submissionAnswerContent: submissionAnswerContent,
                  commentContent: commentContent
                };
                _context.next = 7;
                return this.submissionRepository.createAnswerComment(createAnswerComment);

              case 7:
                createAnswerCommentOrError = _context.sent;

                if (!createAnswerCommentOrError.isFailure) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", Result.fail(createAnswerCommentOrError.error));

              case 10:
                answer.addAnswerComment(commentContent, commentId, submissionAnswerContent);
                return _context.abrupt("return", Result.ok(answer));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateAnswerCommentUseCase;
}(UseCase);